import React, {useState, useEffect, Fragment} from 'react'
import {Box} from "@material-ui/core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import moment from "moment";
import {MapDispatchToProps, MapStateToProps, connect} from "react-redux";
import {caseAccept, caseReject} from "../../vendors/actions/case";
import {toggleBox, setBoxParams} from "../../vendors/actions/layout";
import {stringGenerator} from "../../vendors/utils/common";
import Layout from "../../vendors/redux/reducers/layout";

interface Props {
    data: {
        text: string,
        description?: string,
        date?: string
    }
}

interface BoxData {
    id: string,
    isLong: boolean,
    txtLength: number
}

interface ConnectStateProps {
    Layout: Layout
}

interface ConnectDispatchProps {
    setBoxParams: (data: BoxData) => void;
    toggleBox: (data: string) => void;
}

const DescriptionBox = (props: any) => {
    const {text, description, date, caseStatus, className} = props.data,
        [boxId] = useState(stringGenerator(10)),
        [boxData, setBoxData] = useState({
            id: null,
            isLong: false,
            txtLength: null
        });


    useEffect(() => {
        if (caseStatus >= 0) {
            props.setBoxParams({
                id: boxId,
                isLong: text?.length > 333 && caseStatus > 0,
                txtLength: text?.length
            })
        } else {
            props.setBoxParams({
                id: boxId,
                isLong: text?.length > 333,
                txtLength: text?.length
            })
        }
    }, [text]);

    useEffect(() => {
        setBoxData(props.Layout.descriptionBoxParams.find((el: { id: string }) => el.id === boxId));
        console.log(boxData)
    }, [props.Layout.descriptionBoxParams]);

    const txtCutter = (txt: string, length: number): string => txt.substring(0, length);
    const toggleBox = (e: any): void => {
        props.toggleBox(boxId);
    };
    const createMarkup = () => {
        const txt = (boxData.isLong ? txtCutter(text, 320) : text).replace(/\n/g, "<br />");
        return {
            __html: `${txt}`
        }
    }

    return (
        <Fragment>
            {text && <Box className='box mb-3'>
                <div className={`mb-1 box-label ${className}`}>
                    <span className='box-heading'>{description}</span>
                    {date && <span className='box-date'>
                        <FontAwesomeIcon icon={['far', 'clock']} className="mr-1"/>
                                    <span className='text-uppercase'>
                                        {moment(date).format('MMM DD, YYYY')}
                                    </span>&nbsp;
                        at {moment(date).format('h:mm A')}
                    </span>}
                </div>
                <div className={`box-text ${className}`}>
                    <span dangerouslySetInnerHTML={createMarkup()}></span>
                    {boxData.isLong && <span onClick={toggleBox} className='more'>...Read More</span>}
                </div>
            </Box>}
        </Fragment>
    )
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, Object>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Layout} = state;
    return {
        Layout,
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, Object>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        setBoxParams: (data: BoxData) => dispatch(setBoxParams(data)),
        toggleBox: (data: string) => dispatch(toggleBox(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DescriptionBox);
